module.exports = __webpack_public_path__ + "img/14Pierce.9568887c.png";